import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 23"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd",
      stroke: "#000"
    }, [
      _createElementVNode("path", {
        fill: "#000",
        "fill-rule": "nonzero",
        "stroke-width": ".3",
        d: "M23.36 11.397 18.943 6.98a.39.39 0 1 0-.552.553l3.751 3.751h-8.43a.39.39 0 0 0 0 .781h8.43l-3.751 3.751a.39.39 0 1 0 .552.553l4.417-4.418a.39.39 0 0 0 0-.553Z"
      }),
      _createElementVNode("path", {
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M16.273 9.377V1H1v21h15.273v-8.106"
      })
    ], -1)
  ])))
}
export default { render: render }